module.exports = __webpack_public_path__ + "img/wallet-pass.5e6896cf.png";